import Invoice from "../models/domain/Invoice";

function escapeCsvCell(value: string | number): string {
  const str = String(value ?? "");
  if (/[",\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export function downloadInvoicesCsv(
  invoices: Invoice[],
  filename: string,
): void {
  const headers = [
    "Invoice #",
    "Patient Name",
    "Doctor",
    "Service",
    "Mode",
    "Status",
    "Billed",
    "Paid",
    "Balance",
  ];

  const rows = invoices.map((inv) => [
    inv.receipt_no,
    inv.patient_name,
    inv.doctor_name,
    inv.particulars?.map((p) => p.description).join(", ") ||
      inv.consult_description ||
      "",
    inv.payment_mode ?? "",
    inv.payment_status,
    inv.total_amount,
    inv.paid_amount,
    inv.pending_amount,
  ]);

  const csv = [headers, ...rows]
    .map((row) => row.map(escapeCsvCell).join(","))
    .join("\n");

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
